module.exports = __webpack_public_path__ + "img/15.3824df6b.jpg";